import React from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";

function MenuCard(props) {
  return (
    <div className='relative z-0 w-80 h-60 bg-primary-100 cursor-pointer
    form1:w-96 form1:h-72 hover:bg-primary-200 hover:scale-105'>
        <h2 className='text-3xl text-white pl-3 pt-3'>{props.text}</h2>
        <LazyLoadImage className='absolute bottom-0 right-0 mr-3 mb-3' src={props.image} alt="">
        </LazyLoadImage>
    </div>
  )
}

export default MenuCard;
